
let API_ROUTE_STRING;
let API_ROUTE_PRICETOOL;
let LEGACY_SITE_STRING;
if (window.location.href.includes("localhost")) {
    API_ROUTE_PRICETOOL = 'https://localhost:44318/'
    API_ROUTE_STRING = 'https://localhost:44379/';

} else if (window.location.href.includes("demo")) {
    API_ROUTE_PRICETOOL = 'https://365demo.virtualdcs.co.uk/';
    API_ROUTE_STRING = 'https://365api-lab.virtualdcs.co.uk/';

} else if(window.location.href.includes("preview")){
    API_ROUTE_PRICETOOL = 'https://preview.cloudcover365.co.uk/';
    API_ROUTE_STRING = 'https://365Api-preview.virtualdcs.co.uk:443/';
}else {
    API_ROUTE_PRICETOOL = 'https://cloudcover365.virtualdcs.co.uk/';
    API_ROUTE_STRING = 'https://365api.virtualdcs.co.uk/';
}
export const API_PRICETOOL_ROUTE = API_ROUTE_PRICETOOL + 'PricingTool';
export const API_ROUTE = API_ROUTE_STRING + 'api/';
//Routes
export const Routes = {
    
    GET_VIEW_PRICEMODEL: 'Email/ViewPriceModel',
    GET_VIEW_PRICEMODEL_FOR500PLUS: 'Email/ViewPriceModelFor500plus',
    GET_TRAIL_REQUEST: 'Email/TrailRequest',
    GET_TENANT_SERVICE: 'TenantService/TenantServices',
    GET_ALL_TERMS: 'TenantService/GetAllTerms',
    GET_TENANT_SERVICE_BY_ID: 'TenantService/TenantServiceById',

}



export const Role = {
    User: 'User',
}
export const ApiVersion = {
    number : '/v7',
}

export const Urls = {
    SERVER_PATH: "https://127.0.0.1:4443/",
    HELP: "https://cloudcover365.virtualdcs.co.uk/helpme/",
}